import { LocalDateRangeModel } from '../../../../../../models';

export class AllocationViewUliSlotModel {
  compartmentId: number;
  compartmentName: string;
  dockId: number;
  dockName: string;
  hubId: number;
  hubName: string;
  slotId: string;
  timeFrame: LocalDateRangeModel;

  constructor(params?: AllocationViewUliSlotModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
